import { IH2OTheme } from '@h2oai/ui-kit';

export const appEventTopStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '2rem',
};

export const dateAreaStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  width: 'auto',
};

export const startDateStyle = {
  marginRight: '1rem',
  width: '170px',
};

export const endDateStyle = {
  width: '170px',
};

export const searchAreaStyle = {};

export const searchStyle = {
  width: '250px',
};

export const tableAreaStyle = {
  marginTop: '10px',
  height: '100%',
};

export const tabStyle = (theme: IH2OTheme) => ({
  display: 'flex',
  borderBottom: `1px solid ${theme.palette?.gray300}`,
});

export const tableStyle = (theme: IH2OTheme) => ({
  backgroundColor: theme.palette?.gray200,
  height: '100%',
  overflowY: 'auto' as 'auto' | 'hidden' | 'scroll' | 'visible',
  overflowX: 'auto' as 'auto' | 'hidden' | 'scroll' | 'visible',
});
